export default function () {
  return {
    all: [],
    current: null,
  };
}
